const pxToRem = (px) => {
    const baseSize = 16;
    return px / baseSize;
};

export { pxToRem };